module.exports = require("./pt-TL.js");